var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button hover",on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }